export default __webpack_public_path__ + "static/media/featured-item-22.8ab77028.png";